module.exports = __webpack_public_path__ + "static/media/roaster.3645c4a2.png";